<template>
  <div>
    <div class="card-item checkin-content">
      <div id="checkin-welcome" class="card-content">
        <b-steps
          v-model="activeStep"
          :animated="isAnimated"
          :rounded="isRounded"
          :has-navigation="hasNavigation"
          :icon-prev="prevIcon"
          :icon-next="nextIcon"
          :label-position="labelPosition"
          :mobile-mode="mobileMode">
          <b-step-item :clickable="isStepsClickable">
            <div class="columns is-desktop is-vcentered">
              <div class="image-check-in column py-0">
                <img src="@/ui/assets/img/questions1.svg" alt="seguridad">
              </div>
              <div class="text-content column is-three-quarters-desktop">
                <h3>¿Qué es el check-in y qué estoy aceptando?</h3>
                <p>
                  El check-in es el momento donde conoces y aceptas las condiciones y servicios
                  de nuestro nuevo sitio privado en creditu.com.
                </p>
                <p style="margin-top:1em">Cuando realices tu check-in <strong>aceptas a:</strong></p>
                <ul style="list-style-type:disc; padding-left: 1.5em">
                  <li>
                    Utilizar <strong>nuestra plataforma de pago</strong>,
                    apenas tu cuota esté disponible.
                  </li>
                  <li>Recibir <strong>nuestros servicios de atención</strong> al cliente.</li>
                </ul>
                <p style="margin-top:1em">✨ Todo en un mismo lugar.</p>
              </div>
            </div>
          </b-step-item>

          <!-- Pregunta desaparece si nunca pagó en Andes -->
          <b-step-item
            v-if="$store.state.currentUser.user.checkIn.paymentByAndes"
            :clickable="isStepsClickable"
            :type="'is-success'">
            <div class="columns is-desktop is-vcentered">
              <div class="image-check-in column py-0">
                <img src="@/ui/assets/img/question2.svg" alt="seguridad">
              </div>
              <div class="text-content column is-three-quarters-desktop">
                <h3>¿Podré volver a pagar por Administradora Andes?</h3>
                <p>
                  Al realizar tu check-in y <strong>después que confirmemos</strong> que tu información fue actualizada a
                  nuestro sistema Creditú, tus dividendos no podrán ser pagados en Andes.
                </p>
                <p>
                  Recibirás una notificación con toda la información.
                </p>
              </div>
            </div>
          </b-step-item>

          <!-- Pregunta desaparece si es cliente nuevo // ahora desaparece para todos los casos -->
          <!-- <b-step-item
            v-if="$store.state.currentUser.user.checkIn.knowAndes"
            :clickable="isStepsClickable"
            :type="'is-success'">
            <div class="columns is-desktop is-vcentered">
              <div class="image-check-in column py-0">
                <img src="@/ui/assets/img/question3.svg" alt="seguridad">
              </div>
              <div class="text-content column is-three-quarters-desktop">
                <h3>¿Qué ocurre si no realizo el check-in?</h3>
                <p>
                  Tu información y dividendos seguirán estando en Andes,
                  deberás pagar por allí tu dividendo y recibirás su atención.<br>
                  Sin embargo, <strong>a partir del 20 de diciembre de 2020</strong>
                  tus dividendos automáticamente serán actualizados
                  al nuevo sistema y <strong>comenzarás a pagar y recibir atención directamente
                    desde tu sitio privado en Creditú.</strong>
                </p>
              </div>
            </div>
          </b-step-item> -->

          <b-step-item :clickable="isStepsClickable" disabled>
            <div class="columns is-vcentered is-desktop">
              <div class="image-check-in column py-0">
                <img src="@/ui/assets/img/question4.svg" alt="seguridad">
              </div>
              <div class="text-content column is-three-quarters-desktop">
                <h3>¿Cuáles medios de pago tendré disponible en Creditú?</h3>
                <p>
                  Podrás pagar tu dividendo dentro de tu sitio privado 100% online con los siguientes medios de pago:
                </p>
                <div class="columns is-centered">
                  <div id="payment-method" class="column is-one-quarter-desktop">
                    <div class="payment-icon"><i class="fas fa-university" /></div>
                    <p><span class="payment-label">Transferencia bancaria</span></p>
                  </div>
                  <div id="payment-method" class="column is-one-quarter-desktop">
                    <div class="payment-icon"><i class="fas fa-credit-card" /></div>
                    <p><span class="payment-label">Servipag</span></p>
                  </div>
                  <div id="payment-method" class="column is-one-quarter-desktop">
                    <div class="payment-icon"><i class="fas fa-money-bill-wave" /></div>
                    <p><span class="payment-label">Depósito en efectivo</span></p>
                  </div>
                  <div id="payment-method" class="column is-one-quarter-desktop">
                    <div class="payment-icon">
                      <img alt="neat logo" src="@/ui/assets/img/neat.svg" class="img-gray">
                    </div>
                    <p><span class="payment-label">Neat Pagos</span></p>
                    <p><span class="pay-method-sub font-size">(Tarjeta de crédito)</span></p>
                  </div>
                </div>
              </div>
            </div>
          </b-step-item>

          <template
            v-if="customNavigation"
            slot="navigation"
            slot-scope="{previous, next}">
            <div class="button-navigation-checkin columns is-mobile">
              <div class="column has-text-left">
                <!-- 1/3 Botón si cliente ya pagó por andes -->
                <b-button
                  v-if="
                    $store.state.currentUser.user.checkIn.paymentByAndes
                      && $store.state.currentUser.user.checkIn.knowAndes
                  "
                  v-show="!previous.disabled"
                  rounded
                  class="is-white step"
                  icon-pack="fas"
                  icon-left="angle-left"
                  @click="progress -= 50"
                  @click.prevent="previous.action">
                  Atrás
                </b-button>
                <!-- 2/3 Botón si cliente nunca pagó por andes -->
                <b-button
                  v-if="
                    !$store.state.currentUser.user.checkIn.paymentByAndes
                      && $store.state.currentUser.user.checkIn.knowAndes
                  "
                  v-show="!previous.disabled"
                  class="is-white step"
                  icon-pack="fas"
                  icon-left="angle-left"
                  @click="progress -= 100"
                  @click.prevent="previous.action">
                  Atrás
                </b-button>
                <!-- 3/3 Botón si cliente es nuevo -->
                <b-button
                  v-if="
                    !$store.state.currentUser.user.checkIn.paymentByAndes
                      && !$store.state.currentUser.user.checkIn.knowAndes
                  "
                  v-show="!previous.disabled"
                  class="is-white step"
                  icon-pack="fas"
                  icon-left="angle-left"
                  @click="progress -= 100"
                  @click.prevent="previous.action">
                  Atrás
                </b-button>
              </div>
              <div class="column has-text-right">
                <!-- 1/3 Botón si cliente ya pagó por andes -->
                <b-button
                  v-if="
                    $store.state.currentUser.user.checkIn.paymentByAndes
                      && $store.state.currentUser.user.checkIn.knowAndes
                  "
                  v-show="!next.disabled"
                  rounded
                  class="is-white step"
                  icon-pack="fas"
                  icon-right="angle-right"
                  @click="progress += 50"
                  @click.prevent="next.action">
                  Siguiente
                </b-button>
                <!-- 2/3 Botón si cliente nunca pagó por andes -->
                <b-button
                  v-if="
                    !$store.state.currentUser.user.checkIn.paymentByAndes
                      && $store.state.currentUser.user.checkIn.knowAndes
                  "
                  v-show="!next.disabled"
                  class="is-white step"
                  icon-pack="fas"
                  icon-right="angle-right"
                  @click="progress += 100"
                  @click.prevent="next.action">
                  Siguiente
                </b-button>
                <!-- 3/3 Botón si cliente es nuevo -->
                <b-button
                  v-if="
                    !$store.state.currentUser.user.checkIn.paymentByAndes
                      && !$store.state.currentUser.user.checkIn.knowAndes
                  "
                  v-show="!next.disabled"
                  class="is-white step"
                  icon-pack="fas"
                  icon-right="angle-right"
                  @click="progress += 100"
                  @click.prevent="next.action">
                  Siguiente
                </b-button>
              </div>
            </div>
          </template>
        </b-steps>
      </div>
      <div class="progress-bar">
        <b-progress size="is-small" type="is-primary" :value="progress" />
      </div>
      <div class="confirmed-term">
        <div class="button-content left transition-slow">
          <!-- 1/3 Botón si cliente ya pagó por andes -->
          <!-- <button
            v-if="$store.state.currentUser.user.checkIn.paymentByAndes && $store.state.currentUser.user.checkIn.knowAndes"
            v-show="activeStep === 3"
            id="backButton"
            class="button is-button-secondary"
            @click="waitCustom">
            Prefiero esperar
          </button> -->
          <!-- 2/3 Botón si cliente nunca pagó por andes -->
          <!-- <button
            v-if="!$store.state.currentUser.user.checkIn.paymentByAndes && $store.state.currentUser.user.checkIn.knowAndes"
            v-show="activeStep === 2"
            id="backButton"
            class="button is-button-secondary"
            @click="waitCustom">
            Prefiero esperar
          </button> -->
        </div>
        <div class="button-content transition-slow">
          <!-- 1/3 Botón si cliente ya pagó por andes -->
          <button
            v-if="$store.state.currentUser.user.checkIn.paymentByAndes && $store.state.currentUser.user.checkIn.knowAndes"
            id="continueButton"
            class="button is-button-primary is-rounded"
            :disabled="!(activeStep === 2)"
            @click="confirmCustom">
            Estoy de acuerdo
          </button>
          <!-- 2/3 Botón si cliente nunca pagó por andes -->
          <button
            v-if="!$store.state.currentUser.user.checkIn.paymentByAndes && $store.state.currentUser.user.checkIn.knowAndes"
            id="continueButton"
            class="button is-button-primary is-rounded"
            :disabled="!(activeStep === 1)"
            @click="confirmCustom">
            Estoy de acuerdo
          </button>
          <!-- 3/3 Botón si cliente es nuevo -->
          <button
            v-if="!$store.state.currentUser.user.checkIn.paymentByAndes && !$store.state.currentUser.user.checkIn.knowAndes"
            id="continueButton"
            class="button is-button-primary is-rounded"
            :disabled="!(activeStep === 1)"
            @click="confirmCustom">
            Estoy de acuerdo
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeStep: 0,
      isAnimated: true,
      isRounded: true,
      isStepsClickable: false,

      hasNavigation: true,
      customNavigation: true,
      isProfileSuccess: false,

      prevIcon: 'chevron-left',
      nextIcon: 'chevron-right',
      labelPosition: 'bottom',
      mobileMode: 'minimalist',

      progress: 0
    };
  },
  methods: {
    confirmCustom() {
      this.$buefy.dialog.confirm({
        title: '¿Todo listo?',
        message: 'Al confirmar, estarás inscrito para una mejor experiencia en creditu.com',
        cancelText: 'Leer de nuevo...',
        confirmText: 'Confirmar check-in',
        canCancel: true,
        type: 'is-success is-rounded',
        onConfirm: () => this.$router.push({ name: 'confirmed' }),
        onCancel: () => { this.activeStep = 0; this.progress = 0; }
      });
    },
    waitCustom() {
      this.$buefy.dialog.confirm({
        title: '¡No hay problema! ',
        message: `Sin embargo, recuerda que a partir del 20 de diciembre de 2020 tus dividendos
                  serán automáticamente actualizados en creditu.com.
                  Un abrazo virtual.`,
        cancelText: 'Volver',
        confirmText: 'De acuerdo',
        canCancel: true,
        type: 'is-success',
        onConfirm: () => this.$router.push({ name: 'welcome' })
      });
    }
  }
};
</script>

<style>
.checkin-content {
  width: 95%;
  margin: 30px auto 50px;
  padding-bottom: 50px;;
  overflow: inherit;
}
.image-check-in {
  margin: 0px auto;
}
.step-item {
  min-height: 30vh;
}
.text-content, h3 {
  font-size: calc(1vw + 0.2em);
  font-family: var(--secondary-font);
}
.button-content {
  font-size: calc(1vw + 0.2em);
}
.button.step .icon {
  color: var(--primary);
}
.image-check-in {
    width: 13rem;
}
.confirmed-term {
  margin: 30px;
  padding: 5px;
}
.progress-bar {
  padding-top: 40px;
  padding-bottom: 20px;
  max-width: 90%;
  margin: auto;
}
.button-content {
  margin: auto;
}

.confirmed-term{
  display: flex;
}
.modal-card-head {
  background-color: white;
  border-bottom: none;
}
.modal-card-foot {
  background-color: white;
  border-top: none;
}
.button.is-success:focus {
  box-shadow: none !important;
}
.modal-card-foot .button {
  border: 1px solid #00CCD1;
  border-radius: 50rem;
  color: #00CCD1;
}
.button.is-success {
  border: none !important;
  color: white !important;
}
.dialog.has-custom-container {
  position:fixed;
}
#payment-method {
  background: rgb(77 77 77 / 4%);
  margin: 5px;
  text-align: center;
  border-radius: 30px;
  margin-top: 30px;
  margin-bottom: 30px;
  max-width: 150px;
  line-height: 1em;
}
.payment-icon {
  font-size: 30pt;
  height: 65px;
  padding:5px;
  margin-top: 0px;
}
.payment-icon img {
  max-height: 100%;
  margin-top: 5px;
}
.payment-label {
  font-size: 0.85em;
  line-height: 1pt;
  color: var(--primary);
}
.pay-method-sub {
  font-size: 0.85em;
  line-height: 1pt;
  color: var(--secondary);
}
.mention {
  font-size: 0.7em;
}

.img-gray {
  padding-bottom: 20px !important;
  filter: grayscale(1.5) brightness(0.735);
}

.font-size {
  font-size: 15px;
}

@media (min-width: 600px) {
.button-content.left {
  width: 50%;
}
}

@media (max-width: 1100px) {
.text-content, h3 {
  font-size: calc(1vw + 0.4em);
  font-family: var(--secondary-font);
}
.button.step {
  font-size: calc(1vw + 0.3em);
}
}
@media (max-width: 768px) {
  .text-content, h3 {
    font-size: calc(1vw + 0.6em);
    font-family: var(--secondary-font);
  }
  .button.step {
    font-size: calc(1vw + 0.5em);
    padding: 10px 30px;
  }
  #payment-method {
    margin-right: auto;
    margin-left: auto;
}
  .payment-icon {
    height: 85px;
    padding-top:25px;
    margin-top: 20px;
  }
}
@media (max-width: 600px) {
  h3 {
    font-size: calc(1vw + 0.8em);
  }
  .card-content {
    padding-left: 0px;
    padding-right: 0px;
  }
  .button-content {
    padding: 10px 30px;
    margin: 5px auto;
  }
  .confirmed-term{
    display: grid;
  }
}
@media (max-width: 450px) {
  .button-content {
    padding: 0px;
  }
  .confirmed-term{
    margin:0px;
  }
}
@media (max-width: 380px) {
  #checkin-welcome {
      padding: 0px;
  }
  .button-navigation-checkin {
    zoom: 0.8;
  }
}

</style>
